import { ModelCollectionBase } from "./Collections";

export class Model<MODEL_COLLECTION extends ModelCollectionBase> {

}